import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

// Wraps the jQuery daterangepicker plugin in a Turbo-safe lifecycle.
// Connect/disconnect map cleanly to Turbo cache + DOM replacement.
export default class extends Controller {
  static values = {
    opens: { type: String, default: "left" },
    drops: { type: String, default: "down" },
    placeholder: String,
    cancelClears: { type: Boolean, default: true },
  }

  connect() {
    if (!this.element) return
    if (typeof $.fn?.daterangepicker !== "function") return

    // Prevent double-init if Turbo restores from cache.
    if ($(this.element).data("daterangepicker")) return

    $(this.element).daterangepicker(
      {
        opens: this.opensValue,
        drops: this.dropsValue,
        // Never let the plugin write into the input on its own (it would
        // fill an intentionally empty field with today's date on every
        // re-init, e.g. after a Turbo cache restore). The value is only
        // set in the apply handler below.
        autoUpdateInput: false,
        locale: {
          format: "DD.MM.YYYY",
          separator: " - ",
          applyLabel: "Speichern",
          cancelLabel: "Löschen",
          fromLabel: "From",
          toLabel: "To",
          customRangeLabel: "Custom",
          weekLabel: "W",
          daysOfWeek: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          monthNames: [
            "Januar",
            "Februar",
            "M&auml;rz",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember",
          ],
          firstDay: 1,
        },
        applyButtonClasses: "btn-secondary text-white",
        cancelButtonClasses: "btn-danger text-white",
        cancelClass: "cancel-button-class",
      },
      () => {}
    )

    // Placeholder behavior (keeps your existing UX).
    if (this.hasPlaceholderValue) {
      this.element.setAttribute("placeholder", this.placeholderValue)
    }

    // With autoUpdateInput off, the input is only written when the user
    // confirms a range.
    $(this.element).on("apply.daterangepicker.stimulus", (_event, picker) => {
      this.element.value =
        `${picker.startDate.format(picker.locale.format)}` +
        `${picker.locale.separator}${picker.endDate.format(picker.locale.format)}`
    })

    // If user cancels, clear input (mirrors existing event.js behavior).
    if (this.cancelClearsValue) {
      $(this.element).on("cancel.daterangepicker.stimulus", () => {
        this.element.value = ""
        if (this.hasPlaceholderValue) this.element.blur()
      })
    }
  }

  disconnect() {
    if (!this.element) return
    const instance = $(this.element).data("daterangepicker")
    if (instance && typeof instance.remove === "function") {
      instance.remove()
    }
    $(this.element).off(".stimulus")
  }
}
